import $ from 'jquery'

$(document).ready( initResources )

function initResources(){
    
  let ajaxurl = SITE.ajaxUrl;
  let $search = '';

  function load_resource_posts(page, resource_cat, resource_format, search){
    $('#resource-posts-list').addClass('loading');
    $('.resources__sidebar').addClass('loading');
    $('#resource-pagination').hide();

    // Data to receive from our server
    // the value in 'action' is the key that will be identified by the 'wp_ajax_' hook
    let data = {
      page: page,
      resource_cat: resource_cat,
      resource_format: resource_format,
      search: search,
      action: "get_resource_posts_ajax"
    };
    // Send the data
    $.post(ajaxurl, data, function(response) {
      // If successful Append the data into our html container
      if (response.length) {
        $("#resource-posts-list").html(response);
        setTimeout(() => {
          $('#resource-posts-list').removeClass('loading');
          $('.resources__sidebar').removeClass('loading');
          $('#resource-pagination').show();
        }, "700");
        //launched video modal on resources cards if card link = vidyard
        $.ajax({
          type: "GET",
          url: "https://play.vidyard.com/embed/v4.js",
          dataType: "script",
          async: false
        });
        $('.post-item__link, .post-item__title a').each(function(e){
          let url = new URL($(this).attr('href'));
          if(url.hostname == 'play.vidyard.com'){
            let videoID = $(this).attr('href').split('/').pop().split('.')[0];
            let videoModal = '<div style="display: none;"><img class="vidyard-player-embed" data-uuid="'+ videoID +'" data-v="4" data-type="lightbox" /></div>';
            $(videoModal).appendTo('body');
            $(this).on('click', function(e){
              e.stopImmediatePropagation();
              e.preventDefault();
              let players = VidyardV4.api.getPlayersByUUID(videoID);
              let player = players[0];
              player.showLightbox();
              return false;
            });
          }
        });
      } else {
        $('#resource-pagination').hide();
        $("#resource-posts-list").html('<div class="resources__no-results"><img class="lazyload" data-src="/wp-content/themes/blend/img/noresults.svg" alt="binocolars" /><h4>No results meet the filtered criteria, please reset filter.</h4></div>');
        $('#resource-posts-list').removeClass('loading');
        $('.resources__sidebar').removeClass('loading');
      }
    });
  }

  function load_resource_pagination(resource_cat, resource_format, search){

    $('#resource-posts-list').addClass('loading');
    $('.resources__sidebar').addClass('loading');
    $('#resource-pagination').hide();

    // Data to receive from our server
    // the value in 'action' is the key that will be identified by the 'wp_ajax_' hook
    let data = {
      resource_cat: resource_cat,
      resource_format: resource_format,
      search: search,
      action: "get_resource_posts_pagination"
    };

    // Send the data
    $.post(ajaxurl, data, function(response) {
      // If successful Append the data into our html container
      $('#resource-pagination').html(response);
      setTimeout(() => {
        $('#resource-posts-list').removeClass('loading');
        $('.resources__sidebar').removeClass('loading');
        $('#resource-pagination').show(); 
      }, "700");
    });
  }

  if ('URLSearchParams' in window) {
    let searchParams = new URLSearchParams(window.location.search);
    let $resource_cat = '';
    let $resource_format = '';
    if ( searchParams.has('topic') ) {
      $resource_cat = searchParams.get('topic');
      $('#resource-cat-buttons button').removeClass('active');
      $('#resource-cat-buttons button[data-cat="'+$resource_cat+'"]').addClass('active');
      if ( $('#resource-cat-buttons button[data-cat="'+$resource_cat+'"]').hasClass('has-children') ) {
        $('#resource-cat-buttons button[data-cat="' + $resource_cat + '"]').siblings('ul').slideDown();
      }
      if ( $('#resource-cat-buttons button[data-cat="'+$resource_cat+'"]').hasClass('js-resource-subfilter') ) {
        $('#resource-cat-buttons button[data-cat="' + $resource_cat + '"]').parent().parent().slideDown();
        $('#resource-cat-buttons button[data-cat="'+$resource_cat+'"]').parent().parent().siblings('.js-resource-filter').addClass('active');
        let $resource_cat_parent = $('#resource-cat-buttons button[data-cat="'+$resource_cat+'"]').parent().parent().siblings('.js-resource-filter').attr('data-cat');
        $('#resource-cat-select').val($resource_cat_parent);
        $('.js-research-topic-label').text($('#resource-cat-buttons button[data-cat="'+$resource_cat_parent+'"]').text());
        $('.js-research-subtopic-label').text(' - '+$('#resource-cat-buttons button[data-cat="'+$resource_cat+'"]').text());
      } else {
        $('#resource-cat-select').val($resource_cat);
        $('.js-research-topic-label').text($('#resource-cat-buttons button[data-cat="'+$resource_cat+'"]').text());
      }
    }
    if ( searchParams.has('format') ) {
      $resource_format = searchParams.get('format');
      $('#resource-format-buttons button').removeClass('active');
      $('#resource-format-buttons button[data-format="'+$resource_format+'"]').addClass('active');
      $('#resource-format-select').val($resource_format);
      $('.js-research-format-label').text($('#resource-format-buttons button[data-format="'+$resource_format+'"]').text());
    }
    load_resource_pagination($resource_cat, $resource_format, $search);
    load_resource_posts(1, $resource_cat, $resource_format, $search);
  } else {
    load_resource_pagination();
    load_resource_posts(1);
  }

  // Handle Search
  $('#resources-search-submit').on('click', function (e) {
    let $current_page = 1;
    let $resource_cat = $('#resource-cat-buttons').find('.active').attr('data-cat');;
    let $resource_format = $('#resource-format-buttons').find('.active').attr('data-format');
    $search = $('#resources-search').val();

    load_resource_pagination($resource_cat, $resource_format, $search);
    load_resource_posts($current_page, $resource_cat, $resource_format, $search);
  });

  $('#resources-search').on('keyup', function (e) {
    if (e.which == 13) {
      let $current_page = 1;
      let $resource_cat = $('#resource-cat-buttons').find('.active').attr('data-cat');;
      let $resource_format = $('#resource-format-buttons').find('.active').attr('data-format');
      $search = $('#resources-search').val();

      load_resource_pagination($resource_cat, $resource_format, $search);
      load_resource_posts($current_page, $resource_cat, $resource_format, $search);
    }
  });

  $('#resources-search').on('search', function (e) {
    if ( $search !=='' ) {
      let $current_page = 1;
      let $resource_cat = $('#resource-cat-buttons').find('.active').attr('data-cat');;
      let $resource_format = $('#resource-format-buttons').find('.active').attr('data-format');
      $search = $('#resources-search').val();

      load_resource_pagination($resource_cat, $resource_format, $search);
      load_resource_posts($current_page, $resource_cat, $resource_format, $search);
    }
  });

  // Handle the dropdown change
  $('#resource-cat-select').on('change',function(){
    let $current_page = 1;
    let $resource_cat = $(this).val();
    let $resource_format = $('#resource-format-select').val();
    $('#resource-cat-buttons .js-resource-filter').removeClass('active');
    $('#resource-cat-buttons .js-resource-filter[data-cat="'+$resource_cat+'"]').addClass('active');
    $('#resource-cat-buttons ul').hide();
    $('.js-research-subtopic-label').text('');
    $('.js-resource-subfilter').removeClass('active');
    if ( $(this).find('option:selected').text() == 'View All' ) {
      $('.js-research-topic-label').text('All topics');
    } else {
      $('.js-research-topic-label').text($(this).find('option:selected').text());
    }
    if ('URLSearchParams' in window) {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set('topic', $resource_cat);
      let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', newRelativePathQuery);
    }
    load_resource_pagination($resource_cat, $resource_format, $search);
    load_resource_posts($current_page, $resource_cat, $resource_format, $search);
  });

  $('#resource-format-select').on('change',function(){
    let $current_page = 1;
    let $resource_cat = $('#resource-cat-select').val();
    let $resource_format = $(this).val();
    $('#resource-format-buttons .js-resource-filter').removeClass('active');
    $('#resource-format-buttons .js-resource-filter[data-format="'+$resource_format+'"]').addClass('active');
    if ( $(this).find('option:selected').text() == 'View All' ) {
      $('.js-research-format-label').text('All formats');
    } else {
      $('.js-research-format-label').text($(this).find('option:selected').text());
    }
    if ('URLSearchParams' in window) {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set('format', $resource_format);
      let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', newRelativePathQuery);
    }

    load_resource_pagination($resource_cat, $resource_format, $search);
    load_resource_posts($current_page, $resource_cat, $resource_format, $search);
  });

  // Handle the filter button clicks
  $('#resource-cat-buttons .js-resource-filter').on('click',function(){
    if ( !$(this).hasClass('active') ) {
      $('#resource-cat-buttons ul').slideUp();
    }
    $('#resource-cat-buttons .js-resource-filter').removeClass('active');
    $(this).addClass('active');
    $(this).siblings('ul').slideDown();
    let $current_page = 1;
    let $resource_cat = $(this).attr('data-cat');
    let $resource_format = $('#resource-format-buttons').find('.active').attr('data-format');
    $('.js-research-subtopic-label').text('');
    $('.js-resource-subfilter').removeClass('active');
    $('#resource-cat-select').val($resource_cat);
    if ( $(this).text() == 'View All' ) {
      $('.js-research-topic-label').text('All topics');
    } else {
      $('.js-research-topic-label').text($(this).text());
    }
    if ('URLSearchParams' in window) {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set('topic', $resource_cat);
      let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', newRelativePathQuery);
    }

    load_resource_pagination($resource_cat, $resource_format, $search);
    load_resource_posts($current_page, $resource_cat, $resource_format, $search);
  });

  $('#resource-cat-buttons .js-resource-subfilter').on('click',function(){
    $(this).parent().siblings().find('.js-resource-subfilter').removeClass('active');
    $(this).addClass('active');
    let $current_page = 1;
    let $resource_cat = $(this).attr('data-cat');
    let $resource_format = $('#resource-format-buttons').find('.active').attr('data-format');
    //$resource_cat_parent = $(this).parent().parent().siblings().find('js-resource-filter').attr('data-cat');
    //$('#resource-cat-select').val($resource_cat_parent);
    $('.js-research-subtopic-label').text(' - '+$(this).text());
    if ('URLSearchParams' in window) {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set('topic', $resource_cat);
      let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', newRelativePathQuery);
    }

    load_resource_pagination($resource_cat, $resource_format, $search);
    load_resource_posts($current_page, $resource_cat, $resource_format, $search);
  });

  $('#resource-format-buttons .js-resource-filter').on('click',function(){
    $('#resource-format-buttons .js-resource-filter').removeClass('active');
    $(this).addClass('active');
    let $current_page = 1;
    let $resource_format = $(this).attr('data-format');
    let $resource_cat;
    if ( $('.js-resource-subfilter.active').length ) {
      $resource_cat = $('#resource-cat-buttons ul').find('.active').attr('data-cat');
    } else {
      $resource_cat = $('#resource-cat-buttons').find('.active').attr('data-cat');
    }
    $('#resource-format-select').val($resource_format);
    if ( $(this).text() == 'View All' ) {
      $('.js-research-format-label').text('All formats');
    } else {
      $('.js-research-format-label').text($(this).text());
    }
    if ('URLSearchParams' in window) {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set('format', $resource_format);
      let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', newRelativePathQuery);
    }

    load_resource_pagination($resource_cat, $resource_format, $search);
    load_resource_posts($current_page, $resource_cat, $resource_format, $search);
  });

  // Handle cat link click
  $( ".resources__wrap" ).on('click', '.js-resource-category-opt', function(e){
    e.preventDefault();
    $('#resource-pagination').hide();
    let $current_page = 1;
    let $resource_cat = $(this).data('cat');
    let $resource_format = $('#resource-format-select').val();
    $('#resource-cat-select').val($resource_cat);
    $('#resource-cat-buttons .js-resource-filter').removeClass('active');
    $('#resource-cat-buttons .js-resource-filter[data-cat="'+$resource_cat+'"]').addClass('active');
    $('.js-research-topic-label').text($(this).text());
    $('.js-research-subtopic-label').text('');
    $('#resource-cat-buttons ul').slideUp();
    $('#resource-cat-buttons .active.js-resource-filter[data-cat="'+$resource_cat+'"]').siblings('ul').slideDown();
    $('.js-resource-subfilter').removeClass('active');
    if ('URLSearchParams' in window) {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set('topic', $resource_cat);
      let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', newRelativePathQuery);
    }

    load_resource_pagination($resource_cat, $resource_format, $search);
    load_resource_posts($current_page, $resource_cat, $resource_format, $search);
  });

  // Reset Cat/Format Button
  $( ".resources__sidebar" ).on('click', '.js-resource-reset', function(){
    $('#resource-pagination').hide();
    let $current_page = 1;
    let $resource_cat = '';
    $('#resource-cat-select').val($resource_cat);
    let $resource_format = '';
    $('#resource-format-select').val($resource_format);
    $search = '';
    $('#resources-search').val($search);
    $('#resource-format-buttons .js-resource-filter').removeClass('active');
    $('#resource-cat-buttons .js-resource-filter').removeClass('active');
    $('#resource-format-buttons .js-resource-filter:first').addClass('active');
    $('#resource-cat-buttons .js-resource-filter:first').addClass('active');
    $('.js-research-topic-label').text('All topics');
    $('.js-research-subtopic-label').text('');
    $('.js-research-format-label').text('All formats');
    $('#resource-cat-buttons ul').slideUp();
    $('.js-resource-subfilter').removeClass('active');
    if ('URLSearchParams' in window) {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.delete('format');
      searchParams.delete('topic');
      let newRelativePathQuery = window.location.pathname;
      history.pushState(null, '', newRelativePathQuery);
    }

    load_resource_pagination($resource_cat, $resource_format, $search);
    load_resource_posts($current_page, $resource_cat, $resource_format, $search);
  });

  // Handle the pagination clicks
  $('#resource-pagination').on('click', 'li', function(e){

    $('html, body').animate({
      scrollTop: $("#resource-posts-list").offset().top - 200
    }, 500);

    let $current_li = $('#resource-pagination li.current');

    if($(this).hasClass('prev') || $(this).hasClass('next')) {

      if($(this).css('opacity') == 0) {
        return false;
      }

      if($(this).hasClass('prev')) {

        $current_li.removeClass('current');
        $current_li.prev().addClass('current');
        $current_li = $('#resource-pagination li.current');


        $('#resource-pagination li:not(.prev, .next)').hide();
        $('#resource-pagination li.prev, #resource-pagination li.next').show();

        if($current_li.text() == '1') {
          $('.resources__pagination .prev').css('opacity', '0');
        } else {
          $('.resources__pagination .prev').css('opacity', '1');
        }

        $($current_li).show();
        if($current_li.text() != '1') {
          $($current_li.prev()).show();
        } else {
          $($current_li.next().next()).show();
        }
        $($current_li.next()).show();

      } else if($(this).hasClass('next')) {

        $current_li.removeClass('current');
        $current_li.next().addClass('current');
        $current_li = $('#resource-pagination li.current');
        $('#resource-pagination li:not(.prev, .next)').hide();
        $('#resource-pagination li.prev, #resource-pagination li.next').show();

        if($current_li.text() == $('#resource-pagination li:not(.prev, .next)').length) {
          $('.resources__pagination .next').css('opacity', '0');
        } else {
          $('.resources__pagination .next').css('opacity', '1');
        }

        $($current_li).show();
        $($current_li.prev()).show();
        if($current_li.text() != $('#resource-pagination li:not(.prev, .next)').length) {
          $($current_li.next()).show();
        } else {
          $($current_li.prev().prev()).show();
        }

        $($current_li.prev()).show();
      }

    } else {
      $('#resource-pagination li').removeClass('current');
      $(this).addClass('current');
      $current_li = $('#resource-pagination li.current');
      $('#resource-pagination li:not(.prev, .next)').hide();
      $current_li.show();
      if($current_li.text() != '1') {
        $($current_li.prev()).show();
      } else {
        $($current_li.next().next()).show();
      }

      if($current_li.text() != $('#resource-pagination li:not(.prev, .next)').length) {
        $($current_li.next()).show();
      } else {
        $($current_li.prev().prev()).show();
      }
    }

    $current_li = $('#resource-pagination li.current');
    let $current_page = $($current_li).text();
    let $resource_cat = $('#resource-cat-select').val();
    let $resource_format = $('#resource-format-select').val();

    if($current_page == 1) {
      $('#resource-pagination li.prev').css('opacity', '0');
    } else {
      $('#resource-pagination li.prev').css('opacity', '1');
      $('.archive-resources .featured-resource').addClass('is-category-page');
    }

    if($current_page == $('#resource-pagination li:not(.prev, .next)').length) {
      $('#resource-pagination li.next').css('opacity', '0');
    }  else {
      $('#resource-pagination li.next').css('opacity', '1');
    }

    load_resource_posts($current_page, $resource_cat, $resource_format, $search);

  });
}
